import { getPermissionsForModule, Scopes } from 'src/app/scopes/scopes';
import { CompanieInfo, Companies, Update, InfoBilling } from './Children';

export const CompaniesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'companiesGroup',
      path: 'companies',
      scopes: getPermissionsForModule('Company'),
      children: [
        {
          scopes: [Scopes.Company.show],
          id: 'companiesGroup.main',
          path: '',
          element: <Companies />,
        },
        {
          scopes: [Scopes.Company.update],
          id: 'companiesGroup.update',
          path: 'update',
          element: <Update />,
        },
        {
          scopes: [Scopes.Company.show],
          path: 'info',
          children: [
            {
              id: 'companiesGroup.info',
              path: '',
              element: <CompanieInfo />,
            },
            {
              id: 'companiesGroup.info',
              path: 'billing',
              element: <InfoBilling />,
            },
          ],
        },
      ],
    },
  ],
};
